import api from "../../../lib/api";

export default {
  postDraftImage(data) {
    return api({
      endpoint: "draft-images",
      path: "upload-contents",
      method: "POST",
      body: data
    });
  },
  deleteDraftImage(data) {
    return api({
      endpoint: "draft-images",
      path: "upload-contents",
      method: "DELETE",
      queryParams: data
    });
  },
  postDraftImageComplete(data) {
    return api({
      endpoint: "draft-images-complete",
      path: "upload-contents",
      method: "POST",
      body: data
    });
  },
  postDraft(data) {
    return api({
      endpoint: "draft",
      path: "upload-contents",
      method: "POST",
      body: data
    });
  },
  putDraft(data) {
    return api({
      endpoint: "draft",
      path: "upload-contents",
      method: "PUT",
      body: data
    });
  },
  putDraftImageOrder(data) {
    return api({
      endpoint: "draft-images-order",
      path: "upload-contents",
      method: "PUT",
      body: data
    });
  },
  postDraftThumbnailImage(data) {
    return api({
      endpoint: "draft-thumbnail-image",
      path: "upload-contents",
      method: "POST",
      body: data
    });
  },
  deleteDraftThumbnailImage(data) {
    return api({
      endpoint: "draft-thumbnail-image",
      path: "upload-contents",
      method: "DELETE",
      queryParams: data
    });
  },
  postDraftThumbnailImageComplete(data) {
    return api({
      endpoint: "draft-thumbnail-image-complete",
      path: "upload-contents",
      method: "POST",
      body: data
    });
  },
  postDraftSocialMediaImage(data) {
    return api({
      endpoint: "draft-social-media-image",
      path: "upload-contents",
      method: "POST",
      body: data
    });
  },
  deleteDraftSocialMediaImage(data) {
    return api({
      endpoint: "draft-social-media-image",
      path: "upload-contents",
      method: "DELETE",
      queryParams: data
    });
  },
  postDraftSocialMediaImageComplete(data) {
    return api({
      endpoint: "draft-social-media-image-complete",
      path: "upload-contents",
      method: "POST",
      body: data
    });
  },
  postDraftFrontCoverImage(data) {
    return api({
      endpoint: "draft-front-cover-image",
      path: "upload-contents",
      method: "POST",
      body: data
    });
  },
  postDraftFrontCoverImageComplete(data) {
    return api({
      endpoint: "draft-front-cover-image-complete",
      path: "upload-contents",
      method: "POST",
      body: data
    });
  },
  postDraftBackCoverImage(data) {
    return api({
      endpoint: "draft-back-cover-image",
      path: "upload-contents",
      method: "POST",
      body: data
    });
  },
  postDraftBackCoverImageComplete(data) {
    return api({
      endpoint: "draft-back-cover-image-complete",
      path: "upload-contents",
      method: "POST",
      body: data
    });
  },
  postDraftSpineImage(data) {
    return api({
      endpoint: "draft-spine-image",
      path: "upload-contents",
      method: "POST",
      body: data
    });
  },
  deleteDraftSpineImage(data) {
    return api({
      endpoint: "draft-spine-image",
      path: "upload-contents",
      method: "DELETE",
      queryParams: data
    });
  },
  postDraftSpineImageComplete(data) {
    return api({
      endpoint: "draft-spine-image-complete",
      path: "upload-contents",
      method: "POST",
      body: data
    });
  },
  postPublish(data) {
    return api({
      endpoint: "publish",
      path: "upload-contents",
      method: "POST",
      body: data
    });
  },
  getPublishProgress(data) {
    return api({
      endpoint: "publish-progress",
      path: "upload-contents",
      method: "GET",
      queryParams: data
    });
  },
  postDraftPreview(data) {
    return api({
      endpoint: "draft-preview",
      path: "upload-contents",
      method: "POST",
      body: data
    });
  },
  getDraftPreviewProgress(data) {
    return api({
      endpoint: "draft-preview-progress",
      path: "upload-contents",
      method: "GET",
      queryParams: data
    });
  },
  getIceContentsInitialSettings(data) {
    return api({
      endpoint: "draft-ice-contents-initial-settings",
      path: "upload-contents",
      method: "GET",
      queryParams: data
    });
  },
  updateHybrid3dSettings(data) {
    return api({
      endpoint: "draft-preview-url",
      path: "upload-contents",
      method: "POST",
      body: data
    });
  }
};
